import moment from 'moment';
import { Dashboard, EmbedDashboardResponse } from 'src/generated-api-client';
import { metabaseApi } from 'src/services/apiServices';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { Pager } from 'src/utils/mobx/Pager';
import { RequestHelper } from 'src/utils/RequestHelper';

export type LoansFilter = {
    search?: string;
    issueDateFrom?: moment.Moment;
    issueDateTo?: moment.Moment;
    status?: string[];
};

export class MetabaseStoreClass extends BasicStore<
    Dashboard,
    undefined,
    undefined,
    undefined,
    EmbedDashboardResponse
> {
    pager = new Pager();
    api: BasicStoreApi<Dashboard, EmbedDashboardResponse> = {
        loadList: async () => {
            const response = await RequestHelper.unwrapFromAxiosPromise(
                metabaseApi.getDashboards(),
            );

            this.pager.setTotal(response.dashboards?.length || 0);

            return response?.dashboards || [];
        },
        loadItem: (id, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                metabaseApi.getEmbedDashboard(Number(id), options),
            );
        },
    };
}

export const MetabaseStore = new MetabaseStoreClass();
